module.exports = __webpack_public_path__ + "img/logo.d00f862e.png";